import PropTypes from 'prop-types';

import { Trans, useTransl } from 'shared/lib/i18n';

import ReactSelectInputComponent from '../Select/SelectComponent';

import Info from '../Info';

const BrivoSiteIdSelect = (props) => {
  const { t } = useTransl();

  if (!props?.account)
    return <Info>{t('buildingSettings.noBrivoSiteId')}</Info>;

  if (props?.options?.length === 0)
    return (
      <Trans i18nKey="buildingSettings.noSiteIdWarning">
        <Info isWarning>
          Warning! There is no <b>siteId</b> in the selected account for this
          building
        </Info>
      </Trans>
    );

  return <ReactSelectInputComponent {...props} />;
};

BrivoSiteIdSelect.propTypes = {
  account: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.instanceOf(Array),
};

export default BrivoSiteIdSelect;
